// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0c4d98ac","952":"efbfca5f"}[chunkId] + ".chunk.js";
};